var render = function () {
  var _vm$itemDynamic, _vm$itemDynamic2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('HeaderBreadcrumbs', {
    attrs: {
      "items": [{
        label: 'Dynamic AX',
        to: '/ax/items/register-item-ax'
      }, {
        label: 'Edit'
      }],
      "title": "Edit Dynamic AX"
    }
  }), _c('div', {
    staticClass: "flex-col w-full bg-white shadow-sm rounded-lg px-4 py-4"
  }, [_c('div', {
    staticClass: "w-1/2"
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('label', {
    staticClass: "block text-sm font-medium text-gray-700 mb-2",
    attrs: {
      "for": "name"
    }
  }, [_vm._v(" Product Name ")]), _c('input', {
    staticClass: "w-full rounded-md px-4 border bg-gray-300 text-gray-400 py-2.5 text-sm focus:outline-none focus:ring-2",
    attrs: {
      "id": "ProductName",
      "disabled": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm$itemDynamic = _vm.itemDynamic) === null || _vm$itemDynamic === void 0 ? void 0 : _vm$itemDynamic.ProductName
    }
  })]), _c('div', {
    staticClass: "mb-3"
  }, [_c('label', {
    staticClass: "block text-sm font-medium text-gray-700 mb-2",
    attrs: {
      "for": "name"
    }
  }, [_vm._v(" Name of Printing ")]), _c('input', {
    staticClass: "w-full rounded-md px-4 border bg-gray-300 text-gray-400 py-2.5 text-sm focus:outline-none focus:ring-2",
    attrs: {
      "id": "ProductName",
      "disabled": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm$itemDynamic2 = _vm.itemDynamic) === null || _vm$itemDynamic2 === void 0 ? void 0 : _vm$itemDynamic2.NameOfPrinting
    }
  })]), _vm._l(_vm.itemDynamic, function (value, key) {
    return _c('div', {
      key: key,
      staticClass: "mb-3 px-3"
    }, [_vm.allowedEdit.includes(key) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('label', {
      staticClass: "block text-sm font-medium text-gray-700 mb-2",
      attrs: {
        "for": "name"
      }
    }, [_vm._v(" " + _vm._s(_vm.formatKey(key)) + " ")]), _c('input', {
      staticClass: "w-full rounded-md px-4 border py-2.5 text-sm focus:outline-none focus:ring-2",
      class: _vm.isLoading ? 'bg-gray-300 text-gray-400' : '',
      attrs: {
        "type": "text",
        "placeholder": "",
        "disabled": _vm.isLoading
      },
      domProps: {
        "value": value
      },
      on: {
        "change": function ($event) {
          return _vm.updateValue($event, key);
        }
      }
    })]) : _vm._e()]);
  }), _c('div', {
    staticClass: "mt-4 mb-3 mr-0 flex justify-start"
  }, [_c('button', {
    staticClass: "bg-blue-600 text-white px-4 py-2 rounded-lg mr-3 flex items-center justify-center gap-2",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.editItemAx
    }
  }, [_vm.isLoading ? _c('span', {
    staticClass: "w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"
  }) : _vm._e(), _c('span', [_vm._v(_vm._s(_vm.isLoading ? 'Saving...' : 'Save'))])]), _c('button', {
    staticClass: "bg-whit text-gray-500 border px-4 py-2 rounded-lg",
    attrs: {
      "type": "reset"
    }
  }, [_c('router-link', {
    staticClass: "text-gray-500 no-underline hover:no-underline hover:text-gray-500",
    attrs: {
      "size": "sm",
      "to": {
        path: '/ax/items/register-item-ax'
      }
    }
  }, [_vm._v(" Cancel ")])], 1)])], 2)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }